export var rootURL = new URL(window.location.href).origin
export var apiURL = rootURL + '/api/v1/';
if (window.location.href.includes('localhost')) {
  apiURL = 'http://localhost:5000/api/v1/';
}

const csrf = () => {
  getData('get-csrf')
  .then((res) => {
    let csrfToken = res.headers.get(["X-CSRFToken"]);
    // console.log(csrfToken);
    return csrfToken;
  })
  .catch((err) => {
    console.log(err);
  });
}

// send form data to an api endpoint
export async function postFormData(apiEndpoint, formElement = undefined) {
  let csrfToken = csrf();
  const formData  = new FormData(formElement);
  const response = await fetch(apiURL + apiEndpoint, {
    method: 'POST',
    mode: 'cors',
    headers: {
      "X-CSRFToken": csrfToken
    },
    credentials: 'include',
    body: formData,
  });

  return response;
}

export async function postJsonData(apiEndpoint, data = {}) {
  let csrfToken = csrf();
  const response = await fetch(apiURL + apiEndpoint, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  return response;
}

export function getGETAPILink(apiEndpoint, params = {}) {
  var url = new URL(apiURL + apiEndpoint);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

  return url;
}

export async function getData(apiEndpoint, params = {}) {
  var url = getGETAPILink(apiEndpoint, params)
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    credentials: 'include'
  });

  return response;
}

// return promise with boolean depending on if logged in
export async function isLoggedIn() {
  let res = getData('login-state');
  let promise = new Promise(function(resolve, reject) {
    res.then(response => response.json())
    .then(ret_json => {
      if (ret_json.status === 'success') {
        // ret value if needed
        resolve(true);
      } else if (ret_json.status === 'error') {
        resolve(false);
      }
    }).catch((error) => {
      console.log(error);
      reject(error);
    });
  });
  return promise;
}

export function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function registerWebauthn(residency=false) {
  let response = getData('webauthn/registration-options', {resident: residency});

  response.then(resp => resp.json())
    .then(resp_json => {
      // Pass the options to the authenticator and wait for a response
      return startRegistration(resp_json);
    }).catch(error => {
      // Some basic error handling
      if (error.name === 'InvalidStateError') {
        errorText = 'Error: Authenticator was probably already registered by user';
      } else {
        errorText = error;
      }
      throw error;
    }).then(attResp => {
      return postJsonData('webauthn/validate-registration', attResp)
    }).then(verificationResp => verificationResp.json())
    .then(verificationJson => {
      if (verificationJson && verificationJson.verified) {
        successText = 'Success!';
      } else {
        errorText = `Oh no, something went wrong! Response: ${JSON.stringify(verificationJson)}`;
      }
    }).catch(error => {
      errorText = error;
    });
};

export function authenticateWebauthn(stepup = false) {
  let url = stepup ? 'webauthn/stepup-authentication-options' : 'webauthn/authentication-options';
  let response = getData(url);

  response.then(resp => resp.json())
    .then(resp_json => {
      // Pass the options to the authenticator and wait for a response
      return startAuthentication(resp_json);
    }).catch(error => {
      // Some basic error handling
      errorText = error;
      throw error;
    }).then(asseResp => {
      return postJsonData('webauthn/validate-authentication', asseResp)
    }).then(verificationResp => verificationResp.json())
    .then(verificationJson => {
      if (verificationJson && verificationJson.verified) {
        successText = 'Success!';
      } else {
        errorText = `Oh no, something went wrong! Response: ${JSON.stringify(verificationJson)}`;
      }
    }).catch(error => {
      errorText = error;
    });
};

export function searchTypeToName(val) {
  if (val == 1) { // eCPR
    return "ecpr";
  } else if (val == 2) { // pwc100
    return "pwc100";
  } else if (val == 3) { // bulk ecpr
    return "bulk ecpr";
  };
  return 'unknown';
}